__turbopack_context__.v({
  "container": "styles-module__x3b6yW__container",
  "scrollText": "styles-module__x3b6yW__scrollText",
  "scrollWrapper": "styles-module__x3b6yW__scrollWrapper",
  "textContent": "styles-module__x3b6yW__textContent",
});
